import './scss/index.scss';
import { dcFactory } from 'dc';
import SearchWidgetComponent from './js/search-widget.component';

dcFactory.register(SearchWidgetComponent);
